import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Select } from '@ngxs/store';
import { map, merge, Observable } from 'rxjs';

import { RequestsGetterState } from '../../../core/ngxs/requests-getter.state';
import { FirmService } from '../../../core/services/firm.service';
import { ExtractService } from '../../../core/services/extract.service';
import { ApplicationService } from '../../../core/services/application.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [
    MatProgressSpinner,
    AsyncPipe,
  ],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
  showSpinner$: Observable<boolean>;
  previewIsLoading$ = this.extractService.previewIsLoading$;
  downloadIsLoading$ = this.extractService.downloadIsLoading$;
  manualSpinner$ = this.applicationService.showSpinnerSubject$;

  @Select(RequestsGetterState.getIsLoadingRequest)
  requestLoading$: Observable<boolean>;

  constructor(
    private firmService: FirmService,
    private extractService: ExtractService,
    public applicationService: ApplicationService,
  ) {
    this.showSpinner$ = merge(
      this.requestLoading$, 
      this.previewIsLoading$, 
      this.downloadIsLoading$,
    ).pipe(
      map(isLoading => isLoading)
    );
  }
}
